import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_GET_BY_SLUG,
  SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNTS,
} from 'api/actionTypes';

export default async function getStripeAccounts({ state, apiClient }, { partnerSlug }) {
  typeCheck('partnerSlug::NonEmptyString', partnerSlug);
  const partnerStripeAccountsStatePath = ['partners', 'stripeAccountsByPartnerSlug', partnerSlug];

  const partner = await apiClient.post(SR_API_ACTION_PARTNER_GET_BY_SLUG, { slug: partnerSlug });
  typeCheck('partner::NonEmptyObject', partner);

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNTS,
    payload: {
      partnerId: partner.id,
    },
    state: state,
    onSuccess(stripeAccounts) {
      typeCheck('stripeAccounts::Array', stripeAccounts);
      state.set(partnerStripeAccountsStatePath, stripeAccounts);
      return stripeAccounts;
    },
  });
}
